export default {
  API: {
    SEARCH_SEARCH: 'search',
    SEARCH_PROPOSITION: 'proposition',
    SEARCH_COVERAGES: 'coverage'
  }
};
